import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import "../styles/NewsModalStyles.scss";

const isEmoji = (img) =>
  img.classList.contains("emoji") ||
  img.src.includes("/emoji/") ||
  img.src.includes("img-apple-64");

const NewsModalComponent = ({ onClose, modalContent }) => {
  const [lightboxSrc, setLightboxSrc] = useState(null);
  const [isZoomed, setIsZoomed] = useState(false);

  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, []);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key !== "Escape") return;
      if (lightboxSrc) {
        setLightboxSrc(null);
      } else {
        onClose();
      }
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [onClose, lightboxSrc]);

  const handleContentClick = (e) => {
    const img = e.target.closest("img");
    if (!img || isEmoji(img)) return;
    e.preventDefault();
    setIsZoomed(false);
    setLightboxSrc(img.currentSrc || img.src);
  };

  const closeLightbox = () => setLightboxSrc(null);

  const formatContent = (html) => {
    if (!html) return "";
    return html.replace(/<p><br><\/p>/g, "").trim();
  };

  return (
    <div className="news-fullscreen-modal" role="dialog" aria-modal="true">
      <button
        type="button"
        className="news-fullscreen-close-icon"
        onClick={onClose}
        aria-label="Закрыть"
      >
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <path
            d="M4 4L20 20M20 4L4 20"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
          />
        </svg>
      </button>

      <div
        className="news-fullscreen-content"
        onClick={handleContentClick}
        dangerouslySetInnerHTML={{ __html: formatContent(modalContent) }}
      />

      <button
        type="button"
        className="button-style-4 news-fullscreen-close-button"
        onClick={onClose}
      >
        Закрыть
      </button>

      {lightboxSrc && (
        <div className="news-lightbox" onClick={closeLightbox}>
          <button
            type="button"
            className="news-fullscreen-close-icon news-lightbox-close"
            onClick={closeLightbox}
            aria-label="Закрыть изображение"
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true">
              <path
                d="M4 4L20 20M20 4L4 20"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
              />
            </svg>
          </button>
          <img
            className={`news-lightbox-image${isZoomed ? " is-zoomed" : ""}`}
            src={lightboxSrc}
            alt=""
            onClick={(e) => {
              e.stopPropagation();
              setIsZoomed((prev) => !prev);
            }}
          />
        </div>
      )}
    </div>
  );
};

NewsModalComponent.propTypes = {
  onClose: PropTypes.func.isRequired,
  modalContent: PropTypes.string.isRequired,
};

export default NewsModalComponent;
